module.exports = __webpack_public_path__ + "static/media/eye-simple.29ec9566.svg";